import { GET_DUPLICATE_CARD, GET_DUPLICATE_CARD_SUCCESS, GET_DUPLICATE_CARD_ERROR, GET_DUPLICATE_CARD_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DuplicateCards = (state = initialState, action) => {
  switch (action.type) {
    case GET_DUPLICATE_CARD:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_DUPLICATE_CARD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_DUPLICATE_CARD_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_DUPLICATE_CARD_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DuplicateCards;
